import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchOrderProductsByOfferOrderId } from 'src/api/order-products';
import {
    FETCH_ORDER_PRODUCTS_BY_ORDER_ID,
    requestOrderProducts,
    requestOrderProductsFailure,
    requestOrderProductsSuccess,
} from './actions';

function* fetchOrderProductsByOfferOrderIdSaga(action: AnyAction): SagaIterator {
    yield put(requestOrderProducts(action.orderId));

    const { error, response } = yield call(fetchOrderProductsByOfferOrderId, action.orderId);

    if (error) yield put(requestOrderProductsFailure(error));
    else yield put(requestOrderProductsSuccess(response));
}

export function* generateFetchOrderProductsRepair() {
    yield takeLatest(FETCH_ORDER_PRODUCTS_BY_ORDER_ID, fetchOrderProductsByOfferOrderIdSaga);
}
